<template>
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始时间"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束时间"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.processing_no" placeholder="加工号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.batch_no" placeholder="批次号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.heap_no" placeholder="堆号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.bale_no" placeholder="根号"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.length" placeholder="长度"></el-input>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.diameter" placeholder="直径"></el-input>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.warehouse_id" multiple collapse-tags placeholder="仓库" @visible-change="getWarehouse">
                    <el-option v-for="list in warehouseList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-if="isShowMore" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" @visible-change="getSupplier">
                    <el-option v-for="list in supplierList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
                <!-- <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getBrand">
                    <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select> -->
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="processing.wood.logs" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计</div>
                <div class="totalNumber">件数:{{totalObj.numbers}}</div>
                <div class="totalNumber">立方:{{totalObj.cube}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="processing.wood.logs" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
        </div>
</template>
<script>
    import tabletem from '../../../components/table.vue'
    import pagination from '../../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                isShowMore:false,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    processing_no:"",
                    contract_no:"",
                    bill_lading_no:"",
                    ship_no:"",
                    batch_no:"",
                    breed_id:"",
                    heap_no:"",
                    bale_no:"",
                    length:"",
                    diameter:"",
                    warehouse_id:"",
                    supplier_id:"",
                    remark:"",
                    page:1,
                    per_page:50
                },
                filterDialogVisible:false,
                filter:"",
                fields:"",
                last_page:1,
                total:0,
                selectRow:[],
                warehouseList:[],
                supplierList:[],
                warehouse_id:"",
                pieces:"",
                cube:"",
                return_pieces:"",
                return_cube:"",
                check_cube:"",
                sales_cube:"",
                inbound_time:new Date(),
                selectMap:{
                    breed:[],
                    brand:[],
                    customer:[],
                    warehouse:[]
                },
                breedList:[],
                brandList:[],
                list:[],
                tableCol:[
                    {colName:"加工号",colKey:"processing_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"根号",colKey:"bale_no",colWidth:135,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"长度(m)",colKey:"length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"直径(cm) ",colKey:"diameter",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"根数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"码单立方",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"外币单价",colKey:"foreign_currency_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"采购单价",colKey:"cube_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售单价",colKey:"sales_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"预计到港时间",colKey:"expected_arrival_time",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"预计入库时间",colKey:"expected_storage_time",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{}
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getBreed()
        },
        methods:{
            getWarehouse(){
                this.postFunc("/erp/processing.wood.warehouse",{},res=>{
                    this.warehouseList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSupplier(){
                this.postFunc("/erp/processing.wood.supplier",{},res=>{
                    this.supplierList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBreed(){
                this.postFunc("/erp/processing.wood.breed",{},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params=this.resetSearch(this.params)
                this.params.status=999;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/processing.wood.logs",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj = res.data.data.total;
                    this.list.forEach((item,index)=>{
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time*1000)
                        }else{
                            this.list[index].expected_arrival_time = "";
                        }
                        if(item.expected_storage_time!=0){
                            this.list[index].expected_storage_time = this.formatTime(item.expected_storage_time*1000)
                        }else{
                            this.list[index].expected_storage_time = "";
                        }
                        // this.list[index].original_width_total = parseInt(this.list[index].original_width_total)
                        this.list[index].cube = this.keepLimit(this.list[index].cube)
                        this.list[index].diameter = this.keepLimit(this.list[index].diameter)
                        this.list[index].length = this.keepLimit(this.list[index].length)
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            getRow(row){
                this.selectRow=row;
            },
            toggleSelection(row) {
                this.$refs.outBoundDetailTable.toggleRowSelection(row);
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
